import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authServices: AuthService, private router:Router) { }

  canActivate(){
    if(this.authServices.isLoggedIn()){
      console.log('this.authServices.isLoggedIn()1',this.authServices.isLoggedIn());
      return true;
    }else{
      console.log('this.authServices.isLoggedIn()2',this.authServices.isLoggedIn());
      this.router.navigate(['/login']);
      return false;
    }
  }
}
